// extracted by mini-css-extract-plugin
module.exports = {"file":"H5Editor_file__2hbe-"};